module.exports = {
      id: "palo-english-usage",
      viewBox: "0 0 230 78",
      url: "/" + "svg-sprite-e82dc0c57c0a843613ac9ad873433208.svg#palo-english",
      toString: function () {
        return this.url;
      }
    }